
import React, { useEffect, useRef } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import { ScrollControls, Scroll, useScroll, Billboard} from "@react-three/drei"
import { HiddenText, ParallaxDiv, DistortImage, CascadeText, Rig } from '../helpers'
import { useStore } from '../store'

function Shapes(props) {
    const { width, height } = useThree((state) => state.viewport)
    const data = useScroll()
    useFrame(() => {
      if(data.offset >= 1/16) {
        document.getElementsByTagName('canvas')[0].style.zIndex = 0
      } else {
        document.getElementsByTagName('canvas')[0].style.zIndex = 1
      }
    })

    const transition = useRef(useStore.getState().transition)
    useEffect(() => useStore.subscribe(
      state => (transition.current = state.transition)
    ), [])

    const group = useRef()
    const zoom = (texture, value, enabled) => {
      if(enabled) {
        texture.repeat.set(1 - value, 1 - value)
        texture.offset.set(value / 2, value / 2)
      } else texture.offset.set(0, 0)
    }
    useFrame(() => {
      group.current.children.forEach((child, i) => {
        zoom(child.material.map, data.range(i / 6, 1 / 4) / 4, !transition.current)
      })
    })
    const s = Math.sqrt(width * 3)
    const scale = [s, s*0.59, s]
    return (
      <Billboard
        ref={group}
      >
          <DistortImage show idle={false} position={[0, -height, 0]} scale={scale} url="images/automata.jpg" />
          <DistortImage show idle={false} position={[0, -height*2, 0]} scale={scale} url="images/forest.jpg" />
          <DistortImage show idle={false} position={[0, -height*3, 0]} scale={scale} url="images/folio20.jpg" />
          <DistortImage show idle={false} position={[0, -height*4, 0]} scale={scale} url="images/folio19.jpg" />
          <DistortImage show idle={false} position={[0, -height*5, 0]} scale={scale} url="images/matters.jpg" />
      </Billboard>
    )
  }

  function Item({title, top, small, link, description, year, ...props}) {
    return (
      <div {...props} className="portfolio-item" style={{ position: 'absolute', top, left: '50vw', userSelect: 'none'}}>
         <HiddenText className="heading" delay={0.2} style={{ fontSize: small ? '9vw' : ''}}>{title}</HiddenText>
         <HiddenText className="year" vertical={window.innerWidth <= 650} delay={0.6} single >{year}</HiddenText>
         <HiddenText single vertical className="description" delay={0.8}>{description}</HiddenText>
          <a href={link} target="_blank" rel="noreferrer"  >
            <CascadeText hidden className="link" delay={1}>visit ↗</CascadeText>
          </a>
      </div>
    )
  }
  
  function TextContent(props) {
    return ( 
      <div>
        <ParallaxDiv speed={[8, -5]} >
          <h1 style={{ position: 'absolute', top: 'calc(50vh - 1.4em)', left: '50vw', transform: 'translate(-50%, -50%)', textAlign: 'center'}}>
            <HiddenText show >{`daVid`}</HiddenText>
          </h1>
        </ParallaxDiv>
        <ParallaxDiv speed={[7, 10]} >
          <h1 style={{ position: 'absolute', top: 'calc(50vh - 0.5em)', left: '50vw', transform: 'translate(-50%, -50%)', textAlign: 'center'}}>
            <HiddenText show delay={0.2}>{`alimOwski's`}</HiddenText>
          </h1>
        </ParallaxDiv>
        <ParallaxDiv speed={[6, -10]} >
          <h1 style={{ position: 'absolute', top: 'calc(50vh + 0.43em)', left: '50vw', transform: 'translate(-50%, -50%)', 
              textAlign: 'center', fontFamily: 'Zighead'}}> 
            <HiddenText show delay={0.4}>{`CREATIVE`}</HiddenText>
          </h1>
        </ParallaxDiv>
        <ParallaxDiv speed={[5, 15]} >
          <h1 style={{ position: 'absolute', top: 'calc(50vh + 1.4em)', left: '50vw', transform: 'translate(-50%, -50%)', textAlign: 'center'}}>
            <HiddenText show delay={0.6} >{`portfOlio`}</HiddenText>
          </h1>
        </ParallaxDiv>
        <ParallaxDiv speed={1} >
          <div className="side-text" style={{ position: 'absolute', top: '50vh', left: '4vw', transform: 'translate(0, -50%)',
           writingMode: 'vertical-rl', userSelect: 'none'}}>
            <HiddenText show single="true" delay={1.2}>
              {`↤ drag to play ↦ `}
            </HiddenText>
          </div>
        </ParallaxDiv>
        <ParallaxDiv speed={1} >
          <div className="side-text" style={{ position: 'absolute', top: '50vh', right: '-96vw', transform: 'translate(0, -50%)',
           writingMode: 'vertical-rl', userSelect: 'none'}}>
            <HiddenText show single="true" delay={1.2}>
              {`scroll to discover ⟶`}
            </HiddenText>
          </div>
        </ParallaxDiv>
        <Item top={'150vh'} title={'art aUtomAta'} description={'node script posting random generative art to facebook'} year={'2018-19'} link='https://facebook.com/artautomata' />
        <Item top={'250vh'} title={'NiGhtglAde'} description={'webgl sketch of a forest'} year={'2022'} link='https://dvalim.github.io/webgl-forest'/>
        <Item top={'350vh'} title={'PortfOlio v2'} description={'2020 portfolio'} year={'2020'} link='https://dvalim.github.io/folio20'/>
        <Item top={'450vh'} title={'poRtFolio v1'} description={'2019 portfolio'} year={'2019'} link='https://dvalim.github.io/dvalim-folio19/'/>
        <Item top={'550vh'} title={'mAttErs oF tHe pen'} small description={'personal art blog'} year={`2017-${new Date().getFullYear() - 2000}`} link='https://mattersofthepen.tumblr.com'/>
      </div>
    )
}

export function Work(props) {
  return (
    <ScrollControls
      pages={6} 
      damping={8}
    >
      <Scroll>
        <Shapes {...props} />
      </Scroll>
      <Scroll html>
        <TextContent />
      </Scroll>
      <Rig />
    </ScrollControls>
  )
}